import React from 'react';
import { string, node } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './SupportBanner.css';

const cx = classnames.bind(styles);

const SupportBanner = ({ className, highlighted, title, children }) => (
  <section className={cx('wrapper', className)}>
    <h5 className={styles.title}>
      {title}
      {highlighted && <span className={styles.highlight}> {highlighted}</span>}
    </h5>

    <div className={styles.sectionGroup}>
      {children}
    </div>
  </section>
);

SupportBanner.propTypes = {
  className: string,
  highlighted: string,
  title: string.isRequired,
  children: node.isRequired
};

SupportBanner.displayName = 'SupportBanner';

export default SupportBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/SupportBanner/SupportBanner.js